// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GC7-","col":"styles_col__-SX_4"};